import { Dictionary } from 'lodash';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { CostRateManagerBaseProps } from 'api/cost-rates';
import { User } from 'api/models';
import { toastService } from 'components/molecules/toast';
import { useTranslation } from 'hooks/use-translation';
import { useAccountDataQuery } from 'queries/account';
import { CostRateDrawer } from './drawer';

export interface CostRateDrawerExtras {
  resourceName: string;
  userLookup: Dictionary<User>;
  onClose: () => void;
}

type Props = CostRateManagerBaseProps & CostRateDrawerExtras;

export const ManageCostRates: FC<Props> = ({
  sourceId,
  sourceType,
  resourceName,
  userLookup,
  onClose,
}) => {
  const errorTitle = useTranslation('failure');
  const errorMessage = useTranslation('error');

  const { data: accountData, isError } = useAccountDataQuery();

  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  useEffect(() => {
    if (isError) {
      toastService({
        title: errorTitle,
        message: errorMessage,
      }).error();
    }
  }, [errorMessage, errorTitle, isError]);

  useEffect(() => {
    setIsDrawerVisible(!!sourceId);
  }, [sourceId]);

  const closeModal = useCallback(() => {
    setIsDrawerVisible(false);
    onClose();
  }, [onClose]);

  return sourceId != null && accountData != null ? (
    <CostRateDrawer
      sourceId={sourceId}
      sourceType={sourceType}
      resourceName={resourceName}
      userLookup={userLookup}
      account={accountData.account}
      isVisible={isDrawerVisible}
      onClose={closeModal}
    />
  ) : (
    <></>
  );
};
